import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useAssetsAbandonModel } from "../assetsAbandonModel";
import Print from "./details/Print";

export function ManageAssetsAbandon() {
    const { selectedRowKeys } = useAssetsAbandonModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print id={selectedRowKeys[0]} />
        </>
    );
}